<style lang="scss" scoped>
.product-detail-page {
  height: 100vh;
  padding-bottom: 180px;
  background-color: #fff;
  overflow: scroll;
  // background-image: ;
  div {
    box-sizing: border-box;
  }
  padding-bottom: 200px;
  .business-info-container {
    display: flex;
    align-items: center;
    background-color: #f1f1f0;
    border-bottom: 4px solid #000;
    height: 108px;
    padding: 40px;
    .avator {
      margin-right: 24px;
      height: 64px;
      width: 64px;
      border-radius: 50%;
      overflow: hidden;
      border: 3px solid #000;
      .avator-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .business-name {
      color: #000;
      font-size: 28px;
      font-weight: 600;
    }
  }
  .product-img {
    width: 750px;
    height: 750px;
    overflow: hidden;
    .img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .msg-container {
    width: 100%;
    background-color: #f1f1f0;
    padding: 26px 32px 60px;
    box-sizing: border-box;
    border-bottom: 2px solid #000;
    border-top: 4px solid #000;
    box-shadow: inset 0px 2px 0px #000000, inset 0px -2px 0px #000000;
    .price {
      height: 60px;
      color: #000000;
      display: flex;
      align-items: flex-end;
      .pre {
        font-weight: 500;
        font-size: 34px;
      }
      .mount {
        font-weight: 700;
        font-size: 62px;
      }
    }
    .product-name {
      font-size: 28px;
      line-height: 42px;
      letter-spacing: 0.02em;
      margin-top: 16px;
      color: #2a2a30;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #2a2a30;
    }
  }

  .bottom {
    border-top: 4px solid #000;
    background-color: #fff;
    padding-bottom: 68px;
    position: fixed;
    width: 100%;
    bottom: 0;
    .operate-container {
      height: 122px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .qrcode-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        .qr-icon {
          width: 50px;
          height: 50px;
          .img {
            height: 100%;
            width: 100%;
          }
        }
        .icon-txt {
          font-size: 24px;
          color: #000;
          margin-top: 16px;
        }
      }
      .add-cart-btn, .buy-btn {
        width: 280px;
        height: 88px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        font-weight: 600;
      }
      .add-cart-btn {
        background-color: #fff;
        color: #2a2a30;
        border: 2px solid #2a2a30;
      }
      .buy-btn {
        color: #fff;
        margin-left: 14px;
        background-color: #2a2a30;
      }
      .opt-btn {
        width: 572px;
        height: 88px;
        background-color: #000000;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        font-weight: 600;
        &.disabled {
          background-color: #e7e7f0;
          color: #828393;
        }
      }
    }
  }
}
</style>

<template>
<div class="product-detail-page">
  <van-empty v-if="!isSupport" image="error" description="非常抱歉，暂不支持此APP扫码" />
  <div v-if="isSupport">
    <div class="business-info-container">
      <div class="avator"  @click="goProductList()">
        <img class="avator-img" :src="businessInfo.avatar" alt="">
      </div>
        <div class="business-name">{{businessInfo.nickName}}</div>

    </div>
    <div class="product-img" @click="previewImage()">
      <img class="img" :src="productInfo.appearancePic" alt="">
    </div>
    <div class="msg-container">
      <div class="price">
        <div class="pre">￥</div>
        <div class="mount">{{productInfo.price / 100}}</div>
      </div>
      <div class="product-name">{{productInfo.productName}}</div>
    </div>
    <div class="bottom">
      <div class="operate-container">
        <div class="qrcode-container" @click="goQrCode()">
          <div class="qr-icon">
            <img class="img" src="https://oss.turingsenseai.com/1623906617474376633.png" alt="">
          </div>
          <div class="icon-txt">二维码</div>
        </div>
        <div v-if="productInfo.status == 1" class="add-cart-btn" @click="addCart()">加入购物车</div>
        <div v-if="productInfo.status == 1" class="buy-btn" @click="buyNow()">立即购买</div>
        <div v-if="productInfo.status == 2" class="opt-btn disabled">已售罄</div>
      </div>
    </div>
    <cart-float/>
  </div>
</div>
  
</template>

<script>
import { fetchProductDetail, genOrder, fetchPay, addToCart } from '../../../common/api/purchase'
import { HOST_ADDRESS } from '../../../common/constant'
import { ImagePreview } from 'vant'
import  CartFloat from './../components/cart.vue'
import { Toast } from 'vant'

export default {
  // components:
  components: {
    'cart-float': CartFloat,
  },
  data() {
    return {
      pid: '',
      productInfo: {},
      businessInfo: {},
      isSupport: true
    }
  },
  created() {
    const { pid } = this.$route.params
    this.pid = pid
    let userAgent=window.navigator.userAgent
    if(userAgent.indexOf('QQ')>0 ||  //QQ
      userAgent.indexOf('AlipayClient')>0          //支付宝             
    ){
      this.isSupport=false
    }else{
      this.getProductDetail()
    }
  },
  watch: {
    $route() {
      const { pid } = this.$route.params
      this.pid = pid
      this.getProductDetail()
    }
  },
  methods: {
    getProductDetail() {
      fetchProductDetail({ pid: this.pid })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.productInfo = res.productInfo;
            this.businessInfo = res.MerchantInfo;
          }
        })
    },
    goQrCode() {
      this.$router.push(`/purchase/qrcode/${this.pid}?name=${this.businessInfo.nickName}&price=${this.productInfo.price / 100}&desc=${this.productInfo.productName}`)
      // this.$router.push(`/bag-show/qrcode?pid=${this.pid}&name=${this.businessInfo.nickName}&price=${this.productInfo.price / 100}&desc=${this.productInfo.productName}`)
    },
    goProductList() {
      this.$router.push(`/purchase/product-list/${this.businessInfo.uid}`)
    },
    buyNow() {
      genOrder({ pids: this.pid })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.getProductDetail()
            this.$router.push({ path: `/purchase/pay-page?pid=${this.pid}&orderNo=${res.orderNo}&payMount=${this.productInfo.price / 100}` })
            // fetchPay({ orderNo: res.orderNo, payType: 'alipay', quitUrl: `${HOST_ADDRESS()}bag-show/preroduct-detail/${this.pid}` })
            //   .then(res => {
            //     if (res && res.errorCode == 0) {
            //       window.location.href = res.payUrl
            //     }
            //   })
          }
        })
    },
    previewImage() {
      ImagePreview([this.productInfo.appearancePic])
    },
    addCart() {
      // 添加到购物车
      addToCart({ pids: this.pid })
        .then(res => {
          if (res && res.errorCode == 0) {
            Toast.success('加入购物车成功')
          }
        })
    }
  }
}
</script>